export const ISO_DATE_RE = /^\d{4}-\d{2}-\d{2}/;

/** Local part, @, and a dotted domain. Matches libs/email_validation.py. */
const EMAIL_RE = new RegExp(
  "^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@"
  + '[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?'
  + '(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$',
);

export function isValidEmailAddress(value) {
  const text = String(value ?? '').trim();
  return EMAIL_RE.test(text);
}

export function isPositiveIntegerDays(value) {
  const text = String(value ?? '').trim();
  return /^\d+$/.test(text) && parseInt(text, 10) > 0;
}

export function isDaysOrIsoDate(value) {
  if (isPositiveIntegerDays(value)) return true;
  const text = String(value ?? '').trim();
  return ISO_DATE_RE.test(text);
}

export function isSigningDateValue(value) {
  const text = String(value ?? '').trim();
  if (!text) return false;
  if (text.toLowerCase() === 'yes') return true;
  return ISO_DATE_RE.test(text);
}

export function isEarnestMoneyValue(value, purchasePrice) {
  const text = String(value ?? '').trim();
  if (!text) return false;
  if (text.includes('%')) {
    const pct = parseFloat(text.replace('%', '').trim());
    if (Number.isNaN(pct) || pct <= 0) return false;
    return purchasePrice != null && String(purchasePrice).trim() !== '';
  }
  const cleaned = text.replace(/[$,]/g, '').trim();
  const amount = parseFloat(cleaned);
  return !Number.isNaN(amount) && amount > 0;
}

export function isHomeWarrantyBuyerRequestValue(value) {
  const text = String(value ?? '').trim();
  if (!text) return false;
  if (text.toLowerCase() === 'no') return true;
  const cleaned = text.replace(/[$,]/g, '').trim();
  const amount = parseFloat(cleaned);
  return !Number.isNaN(amount) && amount > 0;
}

export function normalizeStateCode(value) {
  const text = String(value ?? '').trim().toUpperCase();
  if (!text) return '';
  return text.length <= 2 ? text : text.slice(0, 2);
}

/** Address step needs street, city, state, and ZIP (state may come from profile prefill). */
export function isPropertyAddressComplete(data, fallbackState = '') {
  const state = normalizeStateCode(data?.property_address_state || fallbackState);
  const zip = String(data?.property_address_zip_code || '').trim();
  return (
    (data?.property_address || '').trim().length > 0
    && (data?.property_address_city || '').trim().length > 0
    && state.length > 0
    && /^\d{5}$/.test(zip)
  );
}
